import React, {useEffect, useLayoutEffect, useState} from 'react';
import {connect} from 'react-redux';
import {Tracker, Url} from 'finhelper';
import {Navigate, Route, Routes, useNavigate} from 'react-router-dom';
import {NotifyContainer, NotifyManager} from 'notify-component';

import {getServer, getUser, handleAuth, logout} from '#app/redux/actions/auth';
import {getContacts, handleTitle} from '#app/redux/actions/interface';
import {UserContextProvider} from '#app/contexts/UserContext';
import {useUserContext} from '#app/contexts/useUserContext';

import HeaderLanding from '#app/interface/landing/header/Header';
import NotFound from '#app/interface/error/NotFound';
import ErrorBoundary from '#app/interface/error/ErrorBoundary';

import MainPage from '#app/pages/MainPage/MainPage';
import FormOnForbidden from "#app/pages/Auth/Components/FormOnForbidden";

import Layout from './Layout/Layout';
import CabinetRoutes from './CabinetRoutes';

const PagesRouter = (props) => {
    const {auth, getUser, getServer, logout, getContacts} = props;
    const [isActive, setActive] = useState<boolean>();
    const navigate = useNavigate();
    let user = useUserContext(props);

    useLayoutEffect(() => {
        Tracker.init();
        getServer();
        getUser({
            callback: () => {
                setActive(true);
            },
            fallback: () => {
                setActive(true);
            }
        });
    }, []);

    useEffect(() => {
        const supportUrlContainsAnalytics = Url.getCurrentUrl().includes('cohort') || Url.getCurrentUrl().includes('analytics');

        if (props.data.role === 'support' && auth) {
            navigate('cabinet/support');
        } else if (props.data.role === 'marketer' && auth && Url.getCurrentUrl().includes('support')) {
            navigate('cabinet/cohort');
        } else if (
            props.data.role === 'marketer'
            && auth
            && Url.getCurrentUrl().includes('cabinet')
            && !supportUrlContainsAnalytics
        ) {
            navigate('cabinet/cohort');
        } else if (auth && props.data.role === 'marketer' && !Url.getCurrentUrl().includes('cabinet')) {
            navigate('cabinet/cohort');
        }
    }, [auth, props]);

    if (typeof isActive === 'undefined') {
        return null;
    }

    return (
        <ErrorBoundary>
            <UserContextProvider value={user}>
                <Routes>
                    {auth ? (
                        <Route path="/cabinet/*" element={<CabinetRoutes logout={logout} {...props} />}/>
                    ) : (
                        <Route path="/cabinet" element={<Navigate to='/'/>}/>
                    )}
                    <Route
                        element={
                            <>
                                <HeaderLanding/>
                                <Layout/>
                            </>
                        }
                    >
                        <Route path="/" element={<MainPage {...props} />}/>
                        <Route path="/login" element={<FormOnForbidden {...props} />}/>
                        <Route path='*' element={<NotFound {...props} />}/>
                    </Route>
                </Routes>
                <NotifyContainer>
                    <NotifyManager/>
                </NotifyContainer>
            </UserContextProvider>
        </ErrorBoundary>
    );
};

const enhance = connect(
    state => ({
        auth: state.auth.auth,
        data: state.auth.data,
        coursesLoading: state.interfaceComponents.coursesLoading,
    }),
    {getUser, getServer, handleAuth, logout, handleTitle, getContacts}
);

export default enhance(PagesRouter);